"use client"

import React, { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import Modal from "react-modal"
// internal
import baseMenuData, { getFullMenuData, handleBrochureDownload } from "./MobileData"

const MobileMenus = () => {
  const [navTitle, setNavTitle] = useState("")
  const [menuData, setMenuData] = useState(baseMenuData)
  const [loading, setLoading] = useState(true)
  const [showDialog, setShowDialog] = useState(false)
  const location=useLocation()
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: ""
  })

  useEffect(() => {
    const loadMenuData = async () => {
      try {
        const fullMenuData = await getFullMenuData()
        setMenuData(fullMenuData)
      } catch (error) {
        console.error("Failed to load menu data:", error)
      } finally { 
        setLoading(false)
      }
    }

    loadMenuData()
  }, [])

  const openMobileMenu = (menu) => {
    setNavTitle(navTitle === menu ? "" : menu)
  }

  const handleBrochureClick = (e) => {
    e.preventDefault()
    setShowDialog(true)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.mobile || !formData.email) {
      alert("Please fill in all fields");
      return;
    }

    try {
      // Send form data to sendEmail.php
      const response = await fetch('https://palegoldenrod-panther-953114.hostingersite.com/sendEmail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData),
      });

      if (!response.ok) {
        throw new Error('Failed to send email');
      }

      // Trigger brochure download
      // Download the brochure
      const brochureUrl = location.pathname === '/fire'
        ? "/assets/LUMETIQ FIRE DEFENCE-2020.pdf"
        : location.pathname === '/green'
        ? "/assets/LUMETIQ GREEN ENERGY-2020.pdf"
        : "/assets/LUMETIQ CATALOG-2020.pdf";
          const link = document.createElement("a")
          link.href = brochureUrl
          link.download = "Brochure.pdf"
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

      alert("Brochure will be downloaded");
      setShowDialog(false);
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Failed to send email. Please try again.");
    }
  };

  if (loading) return <div className="mean-nav">Loading menu...</div>

  return (
    <>
      <nav className="mean-nav">
        <ul>
          {menuData.map((menu, i) => (
            <React.Fragment key={i}>
              {menu.hasDropdown ? (
                <li className="has-dropdown">
                  <Link to={menu.link}>{menu.title}</Link>
                  <ul className="submenu" style={{ display: navTitle === menu.title ? "block" : "none" }}>
                    {menu.submenus?.map((sub, i) => (
                      <li key={i}><Link to={sub.link}>{sub.title}</Link></li>
                    )) || <li>No items available</li>}
                  </ul>
                  <a
                    className={`mean-expand ${navTitle === menu.title ? "mean-clicked" : ""}`}
                    href="#"
                    onClick={(e) => { e.preventDefault(); openMobileMenu(menu.title) }}
                    style={{ fontSize: "18px" }}
                  >
                    <i className="fal fa-plus"></i>
                  </a>
                </li>
              ) : menu.isBrochure ? (
                <li><a href="#" onClick={handleBrochureClick}>{menu.title}</a></li>
              ) : (
                <li><Link to={menu.link}>{menu.title}</Link></li>
              )}
            </React.Fragment>
          ))}
        </ul>
      </nav>

      <Modal
        isOpen={showDialog}
        onRequestClose={() => setShowDialog(false)}
        contentLabel="Download Brochure"
        style={{
          overlay: {
            zIndex: 999999999
          },
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '10px',
            padding: '40px',
            maxWidth: '500px',
            width: '90%'
          }
        }}
      >
        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Fill the Form to Download Brochure</h2>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <label>Name:</label>
          <input
            type="text"
            placeholder="Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            style={{
              padding: '10px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              width: '100%'
            }}
          />
          <label>Mobile:</label>
          <input
            type="text"
            placeholder="Mobile Number"
            value={formData.mobile}
            onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
            style={{
              padding: '10px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              width: '100%'
            }}
          />
          <label>Email:</label>
          <input
            type="email"
            placeholder="Email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            style={{
              padding: '10px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              width: '100%'
            }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
            <button type="submit" style={{
              padding: '10px 20px',
              borderRadius: '5px',
              border: 'none',
              backgroundColor: '#000',
              color: '#fff',
              cursor: 'pointer'
            }}>Download</button>
            <button onClick={() => setShowDialog(false)} style={{
              padding: '10px 20px',
              borderRadius: '5px',
              border: 'none',
              backgroundColor: '#ccc',
              color: '#000',
              cursor: 'pointer'
            }}>Cancel</button>
          </div>
        </form>
      </Modal>
    </>
  )
}

export default MobileMenus
